import { createSlice } from "@reduxjs/toolkit";

const questionAnswerSlice = createSlice({
  name: "questionAnswer",
  initialState: {
    orderId: "",
    questionAndAnswers: [],
    orderData: null,
  },
  reducers: {
    fetchQuestionAnswer: (state, action) => {
      state.questionAndAnswers = action.payload;
    },
    updateOrderID: (state, action) => {
      state.orderId = action.payload;
    },
    setOrderData: (state, action) => {
      state.orderData = action.payload;
    },
  },
});

export const { fetchQuestionAnswer, updateOrderID, setOrderData } =
  questionAnswerSlice.actions;

export default questionAnswerSlice.reducer;
